import { Component, ViewChild, AfterViewInit, OnInit } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import {
  MatSlideToggleChange,
  MatSlideToggleModule,
} from "@angular/material/slide-toggle";
import { MatSort, MatSortModule } from "@angular/material/sort";
import { MatTableDataSource, MatTableModule } from "@angular/material/table";
import { Router, RouterLink, RouterModule } from "@angular/router";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatSnackBar, MatSnackBarModule } from "@angular/material/snack-bar";
import {
  SolutionService,
  Solution,
  UpdateSolutionRequest,
} from "@kelyn-technologies/dsio-angular-lib/dsio-api";

@Component({
  selector: "app-solutions",
  templateUrl: "./solutions.component.html",
  imports: [
    MatButtonModule,
    MatTableModule,
    MatSortModule,
    MatSlideToggleModule,
    MatProgressBarModule,
    RouterLink,
    RouterModule,
    MatTooltipModule,
    MatSnackBarModule,
  ],
  styleUrls: ["./solutions.component.css"],
})
export class SolutionsComponent implements AfterViewInit, OnInit {
  displayedColumns: string[] = ["solutionName", "status", "action"];
  isloading: boolean = true;
  public tenantId = sessionStorage.getItem("tenantId") as string;
  solutionData: Solution[] = [];
  dataSource = new MatTableDataSource(this.solutionData);

  constructor(
    private readonly solutionService: SolutionService,
    public router: Router,
    private readonly snackBar: MatSnackBar
  ) {}

  @ViewChild(MatSort) sort!: MatSort;

  async ngOnInit(): Promise<void> {
    this.handleGetSolutions();
  }

  ngAfterViewInit(): void {
    this.dataSource.sort = this.sort;
  }

  async handleGetSolutions() {
    this.solutionService.getSolutions().subscribe((response) => {
      this.solutionData = response.solutions;
      this.dataSource.data = this.solutionData;
      this.isloading = false;
    });
  }

  changeStatus(event: MatSlideToggleChange, solutionId: string) {
    const action = event.checked ? "enable" : "disable";

    // Disable the slider immediately when enabling to prevent double actions
    if (action === "enable") {
      event.source.disabled = true;
    }

    this.solutionService
      .updateSolution(solutionId, { action } as UpdateSolutionRequest)
      .subscribe({
        next: (response) => {
          const status = response.solution.status;

          this.solutionData = this.solutionData.map((solution) => {
            if (solution.solution_id === solutionId) {
              return { ...solution, status };
            }
            return solution;
          });
          this.dataSource.data = this.solutionData;

          // Show toast only when enabling
          if (action === "enable") {
            this.showEnableToast();
          }
        },
        error: () => {
          // Revert the UI and re-enable the control on failure
          event.source.checked = !event.source.checked;
          event.source.disabled = false;
          this.snackBar.open(
            "Failed to update solution. Please try again.",
            "Close",
            { duration: 5000 }
          );
        },
      });
  }

  private showEnableToast(): void {
    this.snackBar.open(
      "Solution enabled. You will receive an email with more information.",
      "Close",
      { duration: 5000 }
    );
  }

  public actionHint =
    "Solution needs to be configured before it can be enabled or disabled.";

  isEnabled(solution: Solution) {
    switch (solution.status.toLowerCase()) {
      case "enabled":
        return true;
      case "enabling":
        return true;
      case "disabling":
        return true;
      default:
        return false;
    }
  }

  canToggleState(solution: Solution) {
    switch (solution.status.toLowerCase()) {
      case "configured":
        return true;
      default:
        return false;
    }
  }
}
